export default {
  default: () => import("/app/layouts/default.vue").then(m => m.default || m),
  empty: () => import("/app/layouts/empty.vue").then(m => m.default || m),
  error: () => import("/app/layouts/error.vue").then(m => m.default || m),
  raw: () => import("/app/layouts/raw.vue").then(m => m.default || m)
}